import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const SNAPSHOT_SETTINGS_KEY = 'snapshotViewSettings';

const getSnapshotViewSettings = (snapshotId, conversationViewSettings) => {
  const allSettings = JSON.parse(localStorage.getItem(SNAPSHOT_SETTINGS_KEY) || '{}');
  return {
    ...conversationViewSettings,
    ...allSettings[snapshotId],
  };
};

const saveSnapshotViewSettings = (snapshotId, settings) => {
  const allSettings = JSON.parse(localStorage.getItem(SNAPSHOT_SETTINGS_KEY) || '{}');
  allSettings[snapshotId] = settings;
  localStorage.setItem(SNAPSHOT_SETTINGS_KEY, JSON.stringify(allSettings));
};

export const useSnapshotViewSettingsQuery = (snapshotId, conversationViewSettings) => {
  return useQuery(
    [SNAPSHOT_SETTINGS_KEY, snapshotId],
    () => getSnapshotViewSettings(snapshotId, conversationViewSettings),
    {
      staleTime: Infinity,
      initialData: () => getSnapshotViewSettings(snapshotId, conversationViewSettings),
    },
  );
};

export const useSnapshotViewSettingsMutation = (snapshotId, conversationViewSettings) => {
  const queryClient = useQueryClient();

  return useMutation(
    (newSettings) => {
      const currentSettings = getSnapshotViewSettings(snapshotId, conversationViewSettings);
      const updatedSettings = { ...currentSettings, ...newSettings };
      saveSnapshotViewSettings(snapshotId, updatedSettings);
      return updatedSettings;
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData([SNAPSHOT_SETTINGS_KEY, snapshotId], data);
      },
    },
  );
};
